import { css } from "@emotion/css";
import LogoWithNameIcon from "img/logo_with_name.svg";
import { useTranslation } from "react-i18next";
import routing from "routing";
import { useTawk } from "src/components/TawkMessenger/TawkMessengerProvider";

import {
	OutlinedPrimaryButton,
	PrimaryButton,
} from "../../Default/LekUI/Button";

const ErrorBox = () => {
	const { t } = useTranslation();
	const { openChat, chatUrl } = useTawk();

	return (
		<div className="error-boundary">
			<div className="error-boundary--box basic-box flex flex-col items-center">
				<LogoWithNameIcon
					className={css`
            width: 216px;
          `}
				/>
				<h3 className="size-32 my-16">{t("errors.errorBoundary.header")}</h3>
				<p className="size-24-light text-center my-12">
					{t("errors.errorBoundary.subheader")}
				</p>
				<div className="error-boundary--actions">
					<PrimaryButton
						component={"a"}
						href={routing.paths.home}
						className="mt-16 py-12"
					>
						{t("errors.errorBoundary.buttonText")}
					</PrimaryButton>
					{(chatUrl || openChat) && (
						<OutlinedPrimaryButton
							className="py-12"
							onClick={() => {
								if (chatUrl) {
									window.location.href = chatUrl;
								} else {
									openChat?.();
								}
							}}
						>
							<span>{t("modals.reportTechnicalIssues.buttonText")}</span>
						</OutlinedPrimaryButton>
					)}
				</div>
			</div>
		</div>
	);
};
export default ErrorBox;
